// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs_tabsContainer__1oYsc","tabs":"Tabs_tabs__1X2EC","tab":"Tabs_tab__1NEDM","active":"Tabs_active__25acE","text":"Tabs_text__31tUU"};